import { AmcParticipationStatus, ContributorTypeHistoryRecord, ContributorTypeRequestStatus } from '../models/contributor-type-change.model';

export const CONTRIBUTOR_TYPE_CHANGE_ROUTE = 'contributor-type-change';

export const CONTRIBUTOR_TYPE_HISTORY_ROUTE = 'history';

export const CONTRIBUTOR_TYPE_HISTORY_SEARCH_DEBOUNCE_MS = 300;

export const CONTRIBUTOR_TYPE_HISTORY_DEFAULT_PAGE_SIZE = 10;

/** The backend answers 400 for a longer search term. */
export const CONTRIBUTOR_TYPE_HISTORY_SEARCH_MAX_LENGTH = 128;

export const CONTRIBUTOR_TYPE_STATUS_OPTIONS: readonly ContributorTypeRequestStatus[] = ['PENDING', 'APPROVED', 'REJECTED'];

export const CONTRIBUTOR_TYPE_STATUS_LABEL: Record<ContributorTypeRequestStatus, string> = {
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected'
};

export const CONTRIBUTOR_TYPE_ERROR_MESSAGES = {
    ELIGIBILITY_GENERIC: 'Unable to check this wallet right now. Please try again.',
    REQUEST_GENERIC: 'Unable to send the request right now. Please try again.',
    HISTORY_GENERIC: 'Unable to load contributor type change history right now. Please try again.'
} as const;

const AMC_STATUS_MEMBER = 'willing';
const AMC_STATUS_CLIENT = 'not_willing';

const STATUS_BADGE_CLASS: Record<string, string> = {
    PENDING: 'bg-amber-50 text-amber-700 dark:bg-amber-900 dark:bg-opacity-20 dark:text-amber-300',
    APPROVED: 'bg-green-50 text-green-700 dark:bg-green-900 dark:bg-opacity-20 dark:text-green-300',
    REJECTED: 'bg-red-50 text-red-700 dark:bg-red-900 dark:bg-opacity-20 dark:text-red-300'
};

const STATUS_DOT_CLASS: Record<string, string> = {
    PENDING: 'bg-amber-500',
    APPROVED: 'bg-green-500',
    REJECTED: 'bg-red-500'
};

const STATUS_DEFAULT_BADGE_CLASS = 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:bg-opacity-60 dark:text-gray-300';
const STATUS_DEFAULT_DOT_CLASS = 'bg-gray-400';

/** Client / Member label for a stored status. An unsupported stored value is shown as it is. */
export function contributorTypeLabel(status: AmcParticipationStatus | undefined): string {
    if (status === AMC_STATUS_MEMBER) {
        return 'Member';
    }
    return !status || status === AMC_STATUS_CLIENT ? 'Client' : status;
}

export function contributorTypeStatusBadgeClass(status: string): string {
    return STATUS_BADGE_CLASS[status] ?? STATUS_DEFAULT_BADGE_CLASS;
}

export function contributorTypeStatusDotClass(status: string): string {
    return STATUS_DOT_CLASS[status] ?? STATUS_DEFAULT_DOT_CLASS;
}

export function contributorTypeStatusLabel(status: ContributorTypeRequestStatus): string {
    return CONTRIBUTOR_TYPE_STATUS_LABEL[status] ?? (status || '—');
}

/** Two-letter avatar initials derived from the username, falling back to the email. */
export function contributorTypeInitials(record: ContributorTypeHistoryRecord): string {
    const source = record.username?.trim() || record.email || '?';
    const parts = source.split(/\s+/).filter(Boolean);
    const initials = parts.length > 1 ? `${parts[0][0]}${parts[1][0]}` : source.slice(0, 2);
    return initials.toUpperCase();
}
